//
// Models existing zone placements in the target.
function ANInjectorZoneDistanceHelper(zoneDelegate, logger, target, elementsToIgnore = []){

    if(!zoneDelegate || !(zoneDelegate instanceof ANZoneDelegate)){
        
        throw new Error('Invalid zoneDelegate. Expected an ANZoneDelegate.');
    }

    if(!target || !(target instanceof HTMLElement)){
        
        throw new Error('Invalid target. Expected an HTMLElement.');
    }

    this.__initialized                                     = false;
    this.__zoneDelegate                                    = zoneDelegate;
    this.__logger                                          = logger || new AdsNinjaLogger();
    this.__target                                          = target;
    this.__zonesAbove                                      = [];
    this.__zonesBelow                                      = [];
    this.__paused                                          = false;
    this.__isZoneInParentThatNeedNotBeConsideredDictionary = {};
    elementsToIgnore                                       = elementsToIgnore || [];
    this.__isZoneInParentThatNeedNotBeConsideredSelector   = '';

    elementsToIgnore.forEach(function(elementToIgnore){ 
        
        if(elementToIgnore.ignoreInDensityCalculation){

            if(this.__isZoneInParentThatNeedNotBeConsideredSelector){
                
                this.__isZoneInParentThatNeedNotBeConsideredSelector += ', ';
            }
                
            this.__isZoneInParentThatNeedNotBeConsideredSelector += elementToIgnore.selector;
        }
    }, this);
}

//
// Stop recalculations.
ANInjectorZoneDistanceHelper.prototype.pauseRecalculations = function(){
    
    this.__paused = true;
};

//
// Resume recalculations.
ANInjectorZoneDistanceHelper.prototype.resumeRecalculations = function(){
    
    this.__paused = false;
};

/**
 * Initialize.
 */
ANInjectorZoneDistanceHelper.prototype.initialize = function(){
    
    if(this.__initialized){
        
        // TODO: Add missing zones.
        return;
    }

    this.recalculate();
};

//
// Recalculate.
ANInjectorZoneDistanceHelper.prototype.recalculate = function(){

    if(this.__paused){

        return;
    }

    this.__initialized = true;
    var zonesAbove     = [];
    var zonesBelow     = [];

    // Get list of zone already injected into the target.
    var injectedZoneElements = this.__target.getElementsByClassName('an-zone'); 

    if(!injectedZoneElements || !injectedZoneElements.length){

        return;
    }

    for(var i = 0; i < injectedZoneElements.length; i++){

        var zoneElement = injectedZoneElements[i];
        var key         = zoneElement.dataset.key;

        if(!key){

            this.__logger.error('Unable to find key for zone element.', {
                zoneElement: zoneElement
            });

            return {
                zonesAbove: zonesAbove,
                zonesBelow: zonesBelow,
            };
        }

        var zone   = this.__zoneDelegate.get(key);
        var result = this.__processZone(zone, zoneElement, key, zonesAbove, zonesBelow);
        zonesAbove = result.zonesAbove;
        zonesBelow = result.zonesBelow;
    }

    this.__setZoneLists(zonesAbove, zonesBelow);
};

/**
 * Add a new zone.
 * 
 * @param {ANZoneDictionaryItem} zone
 */
ANInjectorZoneDistanceHelper.prototype.addZone = function(zone, originalUnit){
    
    if(!zone || !(zone instanceof ANZoneDictionaryItem)){

        throw new Error('Invalid zone. Expected an ANZoneDictionaryItem.');
    }

    var zonesAbove = this.__zonesAbove;
    var zonesBelow = this.__zonesBelow;
    var result     = this.__processZone(zone, originalUnit.getAdZoneRootContainerElement(), zone.getKey(), zonesAbove, zonesBelow);

    this.__setZoneLists(result.zonesAbove, result.zonesBelow);
};

//
// Returns nearest zones.
// Used to find the closest zones to an element so that we can make sure we maintain a minimum spacing.
ANInjectorZoneDistanceHelper.prototype.getClosest = function(target){

    if(!target || !(target instanceof HTMLElement)){
        
        throw new Error('Invalid target. Expected an HTMLElement.');
    }

    var targetY          = target.getBoundingClientRect().bottom + window.scrollY;
    var closestZoneAbove = null;
    var closestZoneBelow = null;

    for(var i = 0; i < this.__zonesAbove.length; i++){
        
        var zone = this.__zonesAbove[i];

        if(zone.y <= targetY){
            
            closestZoneAbove = zone;
        }
        else{
            
            break;
        }
    }

    for(var i = 0; i < this.__zonesBelow.length; i++){
        
        var zone = this.__zonesBelow[i];

        if(zone.y >= targetY){
            
            closestZoneBelow = zone;

            break;
        }
    }

    return {
        closestZoneAboveY: (closestZoneAbove) ? closestZoneAbove.y : null,
        closestZoneBelowY: (closestZoneBelow) ? closestZoneBelow.y : null,
    };
};

//
// Determines if target has enough clearence space to inject an ad.
ANInjectorZoneDistanceHelper.prototype.hasSpace = function(target, desiredDistance){

    if(!target || !(target instanceof HTMLElement)){
        
        throw new Error('Invalid target. Expected an HTMLElement.');
    }

    if(target.clientHeight <= 0){
        
        return false;
    }

    var targetBottomY     = window.adsNinja.utils.roundToTwoDecimalPoints(target.getBoundingClientRect().bottom + window.scrollY); // The Y position of the bottom of the target.
    var closestZones      = this.getClosest(target);
    var closestZoneAboveY = closestZones.closestZoneAboveY;
    var closestZoneBelowY = closestZones.closestZoneBelowY;
    var spaceAbove        = (closestZoneAboveY) ? targetBottomY - closestZones.closestZoneAboveY : null;
    var spaceBelow        = (closestZoneBelowY) ? closestZones.closestZoneBelowY - targetBottomY: null;

    // this.__logger.info('Has space?', {
    //     target: target,
    //     desiredDistance: desiredDistance,
    //     spaceAbove: spaceAbove,
    //     spaceBelow: spaceBelow
    // });

    return ((null === spaceAbove || spaceAbove < 0 || (null !== spaceAbove && spaceAbove >= desiredDistance)) && (null === spaceBelow || spaceBelow < 0 || (null !== spaceBelow && spaceBelow >= desiredDistance)));
};

/**
 * Returns true if element is below last injected zone.
 * 
 * @param {HTMLElement} element
 * @returns {boolean}
 */
ANInjectorZoneDistanceHelper.prototype.isElementBelowLastInjectedZone = function(element){
    
    if(!element || !(element instanceof HTMLElement)){

        throw new Error('Invalid element. Expected an HTMLElement.');
    }

    return (this.__zonesBelow[this.__zonesBelow.length - 1].y <= element.getBoundingClientRect().bottom + window.scrollY);
};

/**
 * Process zone.
 * 
 * @param {ANZone} zone 
 * @param {HTMLElement} zoneElement 
 * @param {string} key 
 * @param {Array} zonesAbove 
 * @param {Array} zonesBelow 
 * @returns {Object}
 */
ANInjectorZoneDistanceHelper.prototype.__processZone = function(zone, zoneElement, key, zonesAbove, zonesBelow){

    if(!zone){

        this.__logger.error('Unable to find zone for element.', {
            zoneElement: zoneElement,
            key: key,
        });

        return {
            zonesAbove: zonesAbove,
            zonesBelow: zonesBelow,
        };
    }

    if(!zoneElement || !(zoneElement instanceof HTMLElement) || !key || typeof key !== 'string'){
        
        this.__logger.error('Invalid zone element or key.', {
            zoneElement: zoneElement,
            key: key,
        });

        return {
            zonesAbove: zonesAbove,
            zonesBelow: zonesBelow,
        };
    }

    if(this.__isZoneInParentThatNeedNotBeConsidered(zone, zoneElement)){
        
        return {
            zonesAbove: zonesAbove,
            zonesBelow: zonesBelow,
        };
    }

    // Keep lists of zones already injected with top and bottom y positions.
    var boundingClientRect = zoneElement.getBoundingClientRect();
    var topY               = boundingClientRect.y + window.scrollY;
    var bottomY            = boundingClientRect.bottom + window.scrollY;

    zonesAbove.push({ key: key, y: window.adsNinja.utils.roundToTwoDecimalPoints(bottomY) });
    zonesBelow.push({ key: key, y: window.adsNinja.utils.roundToTwoDecimalPoints(topY) });

    return {
        zonesAbove: zonesAbove,
        zonesBelow: zonesBelow,
    };
};

/**
 * Returns true if the zone is in a parent element that should not be considered.
 * 
 * @param {Object} zone
 * @param {Object} zoneElement 
 * @returns {boolean}
 */
ANInjectorZoneDistanceHelper.prototype.__isZoneInParentThatNeedNotBeConsidered = function(zone, zoneElement){

    if(!zone || !zoneElement || !(zoneElement instanceof HTMLElement)){

        throw new Error('Invalid zone or zone element.');
    }
    else if(!this.__isZoneInParentThatNeedNotBeConsideredSelector || !zoneElement.parentElement){

        return false;
    }

    var key = zone.getKey();

    if(this.__isZoneInParentThatNeedNotBeConsideredDictionary.hasOwnProperty(key)){

        return this.__isZoneInParentThatNeedNotBeConsideredDictionary.hasOwnProperty[key];
    }

    var zoneParentElement = zoneElement.parentElement;

    // Exclude ads that are in sections we don't need to calculate.
    while(zoneParentElement && zoneParentElement != this.__mainContent){

        if(zoneParentElement.matches(this.__isZoneInParentThatNeedNotBeConsideredSelector)){

            this.__isZoneInParentThatNeedNotBeConsideredDictionary.hasOwnProperty[key] = true;

            return true;
        }

        zoneParentElement = zoneParentElement.parentElement;
    }

    this.__isZoneInParentThatNeedNotBeConsideredDictionary.hasOwnProperty[key] = false;
    
    return false;
};

/**
 * Set zone lists.
 * 
 * @param {Array} zonesAbove 
 * @param {Array} zonesBelow 
 */
ANInjectorZoneDistanceHelper.prototype.__setZoneLists = function(zonesAbove, zonesBelow){
    
    // Sort lists.
    zonesAbove.sort((a, b) => a.y - b.y);
    zonesBelow.sort((a, b) => a.y - b.y);

    // this.__logger.debug('Recalculated zones.', {
    //     zonesAbove: zonesAbove,
    //     zonesBelow: zonesBelow
    // });

    this.__zonesAbove = zonesAbove;
    this.__zonesBelow = zonesBelow;
};

window.ANInjectorZoneDistanceHelper = ANInjectorZoneDistanceHelper;